import KofiErfassungBelegMixin from "../Mixins/KofiErfassungBelegMixin";

// @vue/component
export default {
  name: "KofiErfassungBeleg",
  mixins: [
    KofiErfassungBelegMixin,
  ],
};
